import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import MicrositeRoutes from "../routes/rpf-routes";
import LoadingComp from "../components/re-usable/loading/loading";

const Layout = () => {
  return (
    <>
      <Suspense fallback={<LoadingComp />}>
        <Routes>
          {MicrositeRoutes.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
          })}
        </Routes>
      </Suspense>
    </>
  );
};

export default Layout;